/**
 * KiekkoKingi section controller: store-faq
 * Kept external so the browser can defer and cache this code.
 */
(() => {
  const kkScript = document.currentScript;
  if (!kkScript) return;

  (() => {
      const sectionId = kkScript.dataset.sectionId;
      const rootId = kkScript.dataset.rootId;
      const initFaq = () => {
        const root = document.getElementById(rootId);
        if (!root || root.dataset.faqInitialized === 'true') return;
        const configNode = root.querySelector('[data-faq-config]');
        if (!configNode) return;
        let config;
        try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
        root.dataset.faqInitialized = 'true';
        root.classList.add('is-enhanced');
        const items = [...root.querySelectorAll('[data-faq-item]')];
        const groups = [...root.querySelectorAll('[data-faq-group]')];
        const filters = [...root.querySelectorAll('[data-faq-filter]')];
        const search = root.querySelector('[data-faq-search]');
        const results = root.querySelector('[data-faq-results]');
        const empty = root.querySelector('[data-faq-empty]');
        const reveal = root.querySelector('[data-faq-reveal]');
        const revealWrap = root.querySelector('[data-faq-reveal-wrap]');
        const openAll = root.querySelector('[data-faq-open-all]');
        const closeAll = root.querySelector('[data-faq-close-all]');
        const cleanups = [];
        let activeGroup = 'all';
        let query = '';
        let expanded = false;
        let internalToggle = false;
        const on = (target, event, handler, options) => {
          if (!target) return;
          target.addEventListener(event, handler, options);
          cleanups.push(() => target.removeEventListener(event, handler, options));
        };
        const normalize = (value) => String(value || '').toLocaleLowerCase('fi-FI').normalize('NFD').replace(/\p{Diacritic}/gu, '').trim();
        const fill = (template, values) => String(template || '').replace(/\{([a-z]+)\}/gi, (match, key) => Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match);
        const syncFilters = () => filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.faqFilter === activeGroup)));
        const applyVisibility = () => {
          let matched = 0;
          let shown = 0;
          const limiting = Boolean(config.limitInitial && !expanded && activeGroup === 'all' && !query);
          items.forEach((item) => {
            const groupMatch = activeGroup === 'all' || item.dataset.faqGroupKey === activeGroup;
            const searchText = normalize(`${item.dataset.faqGroupLabel || ''} ${item.textContent || ''}`);
            const searchMatch = !query || searchText.includes(query);
            const matches = groupMatch && searchMatch;
            if (matches) matched += 1;
            const visible = matches && (!limiting || shown < Number(config.initialCount));
            if (matches) shown += 1;
            item.hidden = !visible;
          });
          groups.forEach((group) => {
            const hasVisible = [...group.querySelectorAll('[data-faq-item]')].some((item) => !item.hidden);
            group.classList.toggle('is-filtered-out', !hasVisible);
          });
          if (empty) empty.classList.toggle('is-visible', matched === 0);
          if (results) results.textContent = config.showResultsCount ? fill(config.resultsTemplate, { count: matched }) : '';
          const canReveal = Boolean(config.limitInitial && activeGroup === 'all' && !query && items.length > Number(config.initialCount));
          if (revealWrap) revealWrap.classList.toggle('is-visible', canReveal);
          if (reveal) reveal.textContent = expanded ? config.showLessText : config.showAllText;
        };
        const handleToggle = (event) => {
          if (internalToggle || config.openMode !== 'single' || !event.currentTarget.open) return;
          internalToggle = true;
          items.forEach((item) => { if (item !== event.currentTarget) item.open = false; });
          internalToggle = false;
        };
        if (config.openMode === 'all') items.forEach((item) => { item.open = true; });
        if (config.openMode === 'single') {
          let foundOpen = false;
          items.forEach((item) => { if (item.open && foundOpen) item.open = false; else if (item.open) foundOpen = true; });
        }
        items.forEach((item) => on(item, 'toggle', handleToggle));
        filters.forEach((button) => on(button, 'click', () => { activeGroup = button.dataset.faqFilter || 'all'; expanded = true; syncFilters(); applyVisibility(); }));
        on(search, 'input', () => { query = normalize(search.value); expanded = true; applyVisibility(); });
        on(reveal, 'click', () => { expanded = !expanded; applyVisibility(); });
        on(openAll, 'click', () => items.forEach((item) => { if (!item.hidden) item.open = true; }));
        on(closeAll, 'click', () => items.forEach((item) => { item.open = false; }));
        const handleBlockSelect = (event) => {
          if (!event.detail || String(event.detail.sectionId) !== String(sectionId)) return;
          const item = root.querySelector(`[data-block-id="${CSS.escape(String(event.detail.blockId))}"]`);
          if (!item) return;
          activeGroup = 'all'; query = ''; expanded = true;
          if (search) search.value = '';
          syncFilters(); applyVisibility(); item.hidden = false; item.open = true;
        };
        const handleBlockDeselect = () => {};
        on(document, 'shopify:block:select', handleBlockSelect);
        on(document, 'shopify:block:deselect', handleBlockDeselect);
        syncFilters(); applyVisibility();
        root.faqCleanup = () => {
          cleanups.splice(0).forEach((cleanup) => cleanup());
          root.classList.remove('is-enhanced');
          delete root.faqCleanup; delete root.dataset.faqInitialized;
        };
      };
      const matches = (event) => event.detail && String(event.detail.sectionId) === String(sectionId);
      const onLoad = (event) => { if (matches(event)) initFaq(); };
      const onUnload = (event) => {
        if (!matches(event)) return;
        const root = document.getElementById(rootId); if (root && root.faqCleanup) root.faqCleanup();
        document.removeEventListener('shopify:section:load', onLoad); document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:load', onLoad);
      document.addEventListener('shopify:section:unload', onUnload);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFaq, { once: true }); else initFaq();
    })();
})();